module.exports = __webpack_public_path__ + "static/media/logo_genexis.03b1a863.png";